<div class="ft-lap">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Feljegyzés-típusok</ion-card-title>
      <ion-card-subtitle>
        Dicséret, intő, figyelmeztető, felszereléshiány… — a név, az ikon és a KRÉTA-megfeleltetés
        itt szerkeszthető. A típus neve a feljegyzéseken is megjelenik.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <div *ngIf="toltodik">Betöltés…</div>
      <ion-note color="danger" *ngIf="hiba">{{ hiba }}</ion-note>

      <div class="ft-uj" *ngIf="!toltodik">
        <ion-button size="small" fill="outline" (click)="ujNyitva = !ujNyitva">
          <ion-icon slot="start" name="add-circle-outline"></ion-icon>Új típus
        </ion-button>
      </div>

      <div class="ft-uj-urlap" *ngIf="ujNyitva">
        <ion-input label="Név *" labelPlacement="stacked" fill="outline" [(ngModel)]="uj.nev" placeholder="pl. Szülői elismerés"></ion-input>
        <ion-input label="Kód (üresen a névből)" labelPlacement="stacked" fill="outline" [(ngModel)]="uj.kod" placeholder="pl. SZULOI_ELISMERES"></ion-input>
        <ion-input label="Ikon (ionicons név)" labelPlacement="stacked" fill="outline" [(ngModel)]="uj.icon" placeholder="pl. ribbon"></ion-input>
        <ion-input label="KRÉTA-kód" labelPlacement="stacked" fill="outline" [(ngModel)]="uj.kreta_kod"></ion-input>
        <ion-input label="KRÉTA-azonosító" labelPlacement="stacked" fill="outline" [(ngModel)]="uj.kreta_id"></ion-input>
        <ion-input label="Sorrend" labelPlacement="stacked" fill="outline" type="number" [(ngModel)]="uj.sorrend"></ion-input>
        <ion-checkbox [(ngModel)]="uj.csak_admin" labelPlacement="end">Csak admin rögzítheti (határozat, záradék, törzslap)</ion-checkbox>
        <ion-checkbox [(ngModel)]="uj.kreta_visszairas" labelPlacement="end">Visszaírás a KRÉTÁ-ba (van KRÉTA-megfelelője)</ion-checkbox>
        <ion-textarea class="ft-szeles" label="Leírás" labelPlacement="stacked" fill="outline" [(ngModel)]="uj.leiras" autoGrow="true" rows="2"></ion-textarea>
        <div class="ft-uj-lab">
          <span class="ft-elonezet"><ion-icon [name]="ikonElonezet(uj.icon)"></ion-icon>{{ uj.nev || 'Előnézet' }}</span>
          <ion-button size="small" color="success" (click)="ujMent()">
            <ion-icon slot="start" name="save-outline"></ion-icon>Felvétel
          </ion-button>
        </div>
      </div>

      <div class="ft-tabla-wrap" *ngIf="!toltodik && tipusok.length">
        <table class="ft-tabla">
          <thead>
            <tr>
              <th style="width:70px">Sorrend</th><th style="min-width:180px">Név</th><th style="min-width:170px">Kód</th>
              <th style="min-width:170px">Ikon</th><th style="min-width:150px">KRÉTA-kód</th><th style="width:110px">KRÉTA-azon.</th>
              <th style="min-width:200px">Leírás</th>
              <th style="width:90px" title="Csak adminisztrátor rögzítheti (határozat, záradék, törzslapra kerülő bejegyzés). A pedagógus választójában nem jelenik meg.">Csak admin</th>
              <th style="width:90px" title="Van-e KRÉTA-megfelelője. Ha nincs (pl. a mobilhasználat engedélye), a feljegyzés csak itt él, a KRÉTA-visszaíró kihagyja.">KRÉTA-ba</th>
              <th style="width:100px">Használat</th><th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of tipusok" [class.ft-inaktiv]="!t.eredeti.aktiv">
              <td><input type="number" [(ngModel)]="t.sorrend" step="10"></td>
              <td>
                <input type="text" [(ngModel)]="t.nev" maxlength="255">
                <small class="ft-jel" *ngIf="!t.eredeti.aktiv">inaktív – új feljegyzéshez nem választható</small>
                <small class="ft-jel" *ngIf="t.mezok_db" [title]="mezoLista(t)">saját mezők: {{ mezoLista(t) }}</small>
              </td>
              <td><input type="text" [(ngModel)]="t.kod" maxlength="100"></td>
              <td>
                <div class="ft-ikon">
                  <ion-icon [name]="ikonElonezet(t.icon)"></ion-icon>
                  <input type="text" [(ngModel)]="t.icon" placeholder="pl. ribbon">
                </div>
              </td>
              <td><input type="text" [(ngModel)]="t.kreta_kod" maxlength="100"></td>
              <td><input type="text" [(ngModel)]="t.kreta_id" maxlength="100"></td>
              <td><textarea [(ngModel)]="t.leiras" rows="1"></textarea></td>
              <td class="ft-kozep">
                <input type="checkbox" [(ngModel)]="t.csak_admin"
                       [title]="t.csak_admin ? 'Csak adminisztrátor rögzítheti' : 'A pedagógus is rögzítheti'">
              </td>
              <td class="ft-kozep">
                <input type="checkbox" [(ngModel)]="t.kreta_visszairas"
                       [title]="t.kreta_visszairas ? 'A KRÉTÁ-ba visszaíródik' : 'Csak a SULINFORM-ban él, a KRÉTÁ-ba nem írjuk vissza'">
              </td>
              <td>
                <span *ngIf="t.hasznalat">{{ t.hasznalat }} feljegyzés</span>
                <span *ngIf="!t.hasznalat" class="halvany">nincs használva</span>
              </td>
              <td class="muvelet">
                <ion-button size="small" fill="clear" color="success" *ngIf="modosult(t)" (click)="ment(t)" title="Mentés">
                  <ion-icon slot="icon-only" name="save-outline"></ion-icon>
                </ion-button>
                <ion-button size="small" fill="clear" color="medium" (click)="aktivValt(t)"
                            [title]="t.eredeti.aktiv ? 'Inaktiválás – új feljegyzéshez nem választható' : 'Aktiválás – újra választható'">
                  <ion-icon slot="icon-only" [name]="t.eredeti.aktiv ? 'eye-off-outline' : 'eye-outline'"></ion-icon>
                </ion-button>
                <span [title]="torlesCim(t)">
                  <ion-button size="small" fill="clear" color="danger" (click)="torol(t)" [disabled]="t.hasznalat > 0">
                    <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                  </ion-button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ion-note color="medium" class="ft-megjegyzes">
        A feljegyzés a típus <b>nevét</b> tárolja: <b>átnevezéskor</b> a meglévő feljegyzéseken is átíródik, és az
        <b>ikon</b> változása is követi őket. A <b>KRÉTA-kód</b> és <b>-azonosító</b> a KRÉTA beírástípusához köti a
        típust. Az ikon az <a href="https://ionic.io/ionicons" target="_blank" rel="noopener">Ionicons</a> készlet
        egy elemének neve. <b>Törölni</b> csak a még nem használt típust lehet; a használtat <b>inaktiválhatod</b>
        (szem ikon) — új feljegyzéshez nem választható, a meglévők nem változnak.<br>
        <b>Csak admin</b>: a törzslapra kerülő bejegyzést, a záradékot és a határozatot csak adminisztrátor
        rögzítheti — a pedagógus választójában nem jelenik meg, és a rendszer a mentést is elutasítja. A
        pedagógus a fokozatokat (figyelmeztetés, intés, megrovás, dicséret) és a tanórai típusokat rögzíti. A már
        meglévő bejegyzéseket mindenki ugyanúgy látja. A KRÉTA-szinkronnal érkező új típusnál a név adja az alapértéket.<br>
        <b>KRÉTA-ba</b>: ha a típusnak nincs KRÉTA-megfelelője (pl. a <i>korlátozott tárgy (mobil) használatának
        engedélyezése</i>, 245/2024. Korm. r. 5. §), kapcsold ki – az ilyen feljegyzés csak itt él, a visszaíró kihagyja.
        A <b>saját mezős</b> típusnál (engedélyező, cél, időtartam, tárgy) a beíró ablak a mezőket kéri, a feljegyzés
        szövegét a rendszer írja belőlük.
      </ion-note>
    </ion-card-content>
  </ion-card>
</div>
